/* ==========================================================================
   Lisen – "Størrelsesguide"-link ved størrelsesvælgeren (Claude, sep. 2026)

   Linket indsprøjtes med JavaScript i stedet for at ligge i
   snippets/variant-button.liquid. To grunde: vi ved først efter harmonikaen
   har delt beskrivelsen op, OM der overhovedet er mål at vise – og så skal
   temaets egen variantkode ikke røres for en tilføjelse, der kan fjernes
   igen ved at slette to filer.

   BEMÆRK NAVNET på vagten nedenfor. Første udgave hed window.LisenMaalguide,
   og scriptet kørte aldrig. Browseren laver nemlig automatisk en global
   variabel ud af ethvert element med et id – og dialogen hedder netop
   id="LisenMaalguide". Vagten så altså sin egen dialog, troede den allerede
   havde kørt, og stoppede. Derfor et navn, der ikke kan kollidere med et id.

   Se snippets/lisen-maalguide.liquid for anledningen.
   ========================================================================== */

(function () {
  if (window.LisenMaalguideKlar) return;
  window.LisenMaalguideKlar = true;

  var FORSOEG = 20;   // harmonikaen bygges af sit eget script; vi venter på den

  function findEtiket() {
    var etiketter = document.querySelectorAll('.variant-wrapper .variant__label');
    for (var i = 0; i < etiketter.length; i++) {
      var t = (etiketter[i].textContent || '').trim();
      /* Liquid tvinger "Størrelse" som tekst for størrelsesvalget, uanset hvad
         optionen hedder i Shopify (Size/Størrelse). */
      if (/^størrelse/i.test(t)) return etiketter[i];
    }
    return null;
  }

  function findMaal() {
    var boks = document.querySelector('.lisen-accordion [data-bucket="fit"]');
    if (!boks) return null;
    var indhold = boks.querySelector('.lisen-accordion__content');
    if (!indhold) return null;
    /* Tom række skal ikke give et link. Et link, der åbner ingenting, er
       værre end intet link. */
    if (!indhold.textContent.trim() && !indhold.querySelector('table,img')) return null;
    return indhold;
  }

  function saet() {
    var dialog = document.getElementById('LisenMaalguide');
    if (!dialog) return true;

    var indhold = findMaal();
    if (!indhold) return false;

    var etiket = findEtiket();
    if (!etiket) return false;
    if (etiket.querySelector('.lisen-maalguide__link')) return true;

    var krop = dialog.querySelector('[data-maalguide-krop]');
    var luk = dialog.querySelector('[data-maalguide-luk]');

    var knap = document.createElement('button');
    knap.type = 'button';
    knap.className = 'lisen-maalguide__link';
    knap.textContent = 'Størrelsesguide';
    etiket.classList.add('lisen-maalguide__vaert');
    etiket.appendChild(knap);

    knap.addEventListener('click', function () {
      /* Kopieres ved hvert klik, så dialogen altid viser det, der står i
         harmonikaen lige nu – én kilde, ingen dublet der kan blive gammel. */
      krop.innerHTML = '';
      krop.appendChild(indhold.cloneNode(true));
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    if (luk) {
      luk.addEventListener('click', function () {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    }

    /* Klik på bagtæppet lukker. <dialog> sender selv klikket til sig selv,
       når man rammer uden for indholdet. */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog && typeof dialog.close === 'function') dialog.close();
    });

    return true;
  }

  function start() {
    var n = 0;
    (function proev() {
      if (saet()) return;
      if (++n >= FORSOEG) return;
      setTimeout(proev, 150);
    })();
  }

  window.LisenMaalguideStart = start;
  document.addEventListener('DOMContentLoaded', start);
  start();
})();
